import React from "react";
import { Navigate } from "react-router-dom";
import routePaths from "./route-paths";
import Login from "../modules/Login";
import Dashboard from "../modules/Dashboard";
import ForgotPassword from "../modules/ForgotPassword";
import ManageUsers from "../modules/ManageUsers";
import ContactForm from "../modules/ContactForm";
import Settings from "../modules/SettingModule";
import BroadcastNotification from "../modules/BroadcastNotification";
import Chats from "../modules/Chats";
import ManageAppData from "../modules/ManageAppData";
import ManageCategories from "../modules/ManageCategories";
import RetentionUsers from "../modules/RetentionUsers";
import ActiveRetentionChart from "../modules/ActiveRetentionChart";

const routes = [
  {
    path: routePaths.HOME,
    element: (props = {}) => <Login {...props} />,
  },
  {
    path: routePaths.RESETPASSWORD,
    element: (props = {}) => <ForgotPassword {...props} />,
  },
];

const loginRoutes = [
  {
    path: routePaths.HOME,
    element: () => <Navigate to={routePaths.DASHBOARD} replace />,
  },
  {
    path: routePaths.DASHBOARD,
    element: (props = {}) => <Dashboard {...props} />,
  },
  {
    path: routePaths.RETENTION,
    element: (props = {}) => <RetentionUsers {...props} />,
  },
  {
    path: routePaths.VISUALIZATION,
    element: (props = {}) => <ActiveRetentionChart {...props} />,
  },
  {
    path: routePaths.MANAGE_USERS,
    element: (props = {}) => <ManageUsers {...props} />,
  },
  {
    path: routePaths.REVIEW_CONTACT_FORM,
    element: (props = {}) => <ContactForm {...props} />,
  },
  {
    path: routePaths.CHAT,
    element: (props = {}) => <Chats {...props} />,
  },
  {
    path: routePaths.PROFILE_SETTINGS,
    element: (props = {}) => <Settings {...props} />,
  },
  {
    path: routePaths.BROADCAST_NOTIFICATIONS,
    element: (props = {}) => <BroadcastNotification {...props} />,
  },
  {
    path: routePaths.MANAGE_APP_DATA,
    element: (props = {}) => <ManageAppData {...props} />,
  },
  {
    path: routePaths.MANAGE_CATEGORIES,
    element: (props = {}) => <ManageCategories {...props} />,
  },
  // {
  //   path: routePaths.NOT_FOUND,
  //   element: () => <Navigate to={routePaths.HOME} replace />,
  // },
];

export { routes, loginRoutes };
